<template>
    <div class="east-operate">
        <div class="left">
            <slot name="left"></slot>
        </div>
        <div class="right">
            <slot name="right"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EastOperate'
}
</script>
<style lang="less" scoped>
.east-operate {
    min-height: 35px;
    padding: 5px 8px;
    .left {
        float: left;
        text-align: left;
    }
    .right {
        float: right;
        text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/east-operate.vue